/**
 * 10.9K8 — FEED DE DROPS RAROS (o "drops ao vivo" do site /site). O jogo avisa o servidor quando o
 * jogador pega um item LENDÁRIO ou MÍTICO; o site lê a tabela `drop_feed`.
 *
 * Quem decide o que entra é a função `report_drop` do banco (supabase/drop_feed.sql): confere
 * raridade/fonte/formato, usa o NOME do perfil (o cliente não escolhe) e limita 20 por hora por
 * jogador. Aqui é só fire-and-forget: sem rede ou sem sessão, não acontece nada e o jogo segue.
 */
import { supabase } from "./supabase";

export type DropSource = "enemy" | "chest" | "boss" | "raid" | "event" | "fusion";

export function reportDrop(defId: string, rarity: string, source: DropSource, classId: string | null): void {
  if (rarity !== "legendary" && rarity !== "mythic") return; // o banco recusaria de qualquer jeito
  try {
    void supabase
      .rpc("report_drop", { p_def: defId, p_rarity: rarity, p_source: source, p_class: classId || null })
      .then(() => undefined, () => undefined);
  } catch { /* nunca atrapalha o jogo */ }
}
